import styleVars from './_styleVars';
import React from 'react';
import styled from 'styled-components';


const Sidebar = styled.div`
  padding: 16px;
  background: ${styleVars.grey1};
`;

function SidebarComponent (props) {
  return (
    <Sidebar>
      <h1>Translation</h1>
      {props.ocrText}
    </Sidebar>
  );
}

export default SidebarComponent;